import { ContentElements } from '../../../models/osb-model/osb-content-details';
import { OSBStep } from '../../../models/osb-model/osb-step';
import OsbUtilService from '../../../services/osb-service/osb-util-service/osb-util-service';
import ServiceHandler from '../../../services/service-handler';

export const callContentService = async (modelName: string) => {
    return await ServiceHandler.OsbV3ContentService.getOsbContentModel(
        OsbUtilService.getAppConfiguration().brand,
        OsbUtilService.getAppConfiguration().countryCode,
        OsbUtilService.getAppConfiguration().languageRegionCode,
        modelName
    );
};

export const getObjectFromAEMJson = (
    key: string,
    data: any[] | ContentElements[]
) => {
    if (data) {
        const item = data.filter(part => {
            return part.name === key;
        });
        if (
            item &&
            item.length > 0 &&
            Object.prototype.hasOwnProperty.call(item[0], 'value')
        ) {
            return item[0].value === null ? '' : item[0].value;
        }
    }
    return '';
};

export const formatRegVinNumber = (
    regVin: string,
    allowSpecialCharacters: boolean
) => {
    if (!allowSpecialCharacters) {
        return regVin
            .replace(/ /g, '')
            .replace(/-/g, '')
            .toUpperCase();
    }
    return regVin.toUpperCase();
};
export const formatOSBPrice = (
    price: string | number | undefined,
    config: OSBStep
): string | null => {
    const numericPrice = Number(price);

    // Case: Invalid or Missing -> Return POR (safe fallback)
    if (price === undefined || price === null || isNaN(numericPrice)) {
        return config.porLabel || '';
    }
    // Case: -1 -> Price on Request
    if (numericPrice === -1) {
        return config.porLabel || 'Price on Request';
    }
    // Case: -2 -> No Display (Empty)
    if (numericPrice === -2) {
        return null;
    }
    // Case: 0 -> Free
    if (numericPrice === 0) {
        return config.freeLabel || 'Free';
    }
    // Default: Format the number
    const precision = config.pricePrecision ?? 2;
    const rawFixed = numericPrice.toFixed(precision);
    const [integerPart, decimalPart] = rawFixed.split('.');

    const separator = config.priceSeparator || ',';
    const formattedInteger = integerPart
        .split('')
        .reverse()
        .reduce((acc, digit, index) => {
            if (index > 0 && index % 3 === 0) {
                return digit + separator + acc;
            }
            return digit + acc;
        }, '');
    const decSeparator = config.decimalSeparator || '.';
    const formattedNumber = decimalPart
        ? `${formattedInteger}${decSeparator}${decimalPart}`
        : formattedInteger;
    const prefix =
        config.pricePrefix && config.pricePrefix !== 'null'
            ? config.pricePrefix
            : '';

    const suffix =
        config.priceSuffix && config.priceSuffix !== 'null'
            ? config.priceSuffix
            : '';

    return `${prefix}${formattedNumber}${suffix}`;
};
